import clsx from 'clsx';
import { HubertButton } from 'components/HubertUI/HubertButton';
import { useUser } from 'hooks/useUser';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { resetCustomEvaluation } from 'rtk/TemplateSlice';
import { EEventType } from 'types/events.enum';

type Props = {
  templateId?: string;
  nodeId: string;
  customKey: string;
  isDefault: boolean;
};

const ResetEvaluationBanner = ({ templateId, nodeId, customKey, isDefault }: Props) => {
  const { t } = useTranslation('Templates');
  const user = useUser();
  const dispatch = useAppDispatch();
  const templateLanguages = useAppSelector<string[]>(
    (state) => state.Template?.present?.c?.language_settings?.list ?? [],
  );

  return (
    <div className={clsx(isDefault && 'hidden', 'bg-info-100', 'rounded-md', 'p-2', 'flex flex-row justify-between')}>
      {t('evaluationPopover.resetBanner')}
      <HubertButton
        size={'sm'}
        variant={'info'}
        onClick={() => {
          if (templateId && user) {
            dispatch(
              resetCustomEvaluation({
                templateId,
                eventType: EEventType.MODIFIED,
                resource: { nodeId, customKey, languages: templateLanguages },
                description: `${user.first_name} ${user.last_name} reset evaluation for ${nodeId}, ${customKey} to original value.`,
              }),
            );
          }
        }}
      >
        {t('evaluationPopover.resetButton')}
      </HubertButton>
    </div>
  );
};

export default ResetEvaluationBanner;
